import { render, staticRenderFns } from "./HorizontalScrollMenu.vue?vue&type=template&id=1957a51f&lang=html&"
import script from "./HorizontalScrollMenu.vue?vue&type=script&lang=js&"
export * from "./HorizontalScrollMenu.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalScrollMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports